module.exports = __webpack_public_path__ + "static/2019-fineArt1-f50414ab23f21fca933de2047c97ece4.jpg";